// extracted by mini-css-extract-plugin
export default {"wrapper":"Banner_wrapper__Jt0KE","banner":"Banner_banner__nJiSk","banner-text":"Banner_banner-text__YwC3P"};